import { PreviewItem } from '../components/commetFileModal';
import { ICourse } from '../types/Courses';
import { SelectFormOption } from '../types/Forms';

//dynamic image
const images = require.context(`/public/assets/images`, true);

export const dynamicImage = (image: string) => {
  return images(`./${image}`);
};

//dynamic Number
export function dynamicNumber(totalLength: number) {
  return Array.from({ length: totalLength }, (_, index) => index + 1);
}
export function enumToSelectOptions<T extends string>(
  enumObj: Record<string, T>,
  tPrefix: string,
  t: (key: string) => string,
): SelectFormOption<T>[] {
  return Object.values(enumObj).map((value) => ({
    value,
    label: t(`${tPrefix}.${value}`),
  }));
}

export const coursesToSelectOptions = (allCourses: ICourse[], pageLang: string): SelectFormOption[] => {
  if (allCourses.length === 0) {
    return [];
  }
  if (allCourses[0].translations.some((t) => t.lang === pageLang)) {
    return allCourses.map((course: ICourse) => ({
      value: String(course.id),
      label: course.translations.find((t) => t.lang === pageLang)?.name || course.name,
    }));
  } else {
    return allCourses.map((course: ICourse) => ({
      value: String(course.id),
      label: course.name,
    }));
  }
};

export const formatDate = (date: string, key: string) => {
  if (key === 'time') {
    return new Date(date).toLocaleDateString('uk-UA', {
      hour: '2-digit',
      minute: '2-digit',
    });
  } else {
    return new Date(date).toLocaleDateString('uk-UA');
  }
};

export const fmtDateTime = (iso: string | null) =>
  iso
    ? new Date(iso).toLocaleString('uk-UA', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })
    : '—';

export const isNewPreview = (p: PreviewItem): p is Extract<PreviewItem, { kind: 'new' }> =>
  p.kind === 'new';
export const revokeObjectUrls = (arr: PreviewItem[]) => {
  arr.forEach((p) => {
    if (isNewPreview(p)) URL.revokeObjectURL(p.url);
  });
};
  // helper to pick readable text color over background
  export const getContrastColor = (hex?: string) => {
    if (!hex) return '#000';
    const cleaned = hex.replace('#', '');
    if (cleaned.length !== 6) return '#000';
    const r = parseInt(cleaned.substring(0, 2), 16);
    const g = parseInt(cleaned.substring(2, 4), 16);
    const b = parseInt(cleaned.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#000' : '#fff';
  };
